import Reservations from 'components/HappeningNonContent/Reservations/Reservations';

export default Reservations;
